<template>
  <div class="container-fluid">
    <page-header
      left-side-class="col-md-8"
      right-side-class="col-xl-4 align-items-end d-flex pb-2 justify-content-end"
      :page="headers.page"
      :actions="headers.actions"
    />
    <roles v-model="model.roles" />
    <sections class="mt-3" v-model="model.sections" />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import Roles from './components/Roles.vue';
import Sections from './components/Sections.vue';

import alerts from '@/mixin/alert.mixin';

import {
  reorganize,
  getReorganization,
} from '@/services/operations/dashboard-management';

const title = 'Añadir Reorganización';

export default {
  name: 'ReorganizeDashboardManageMain',
  mixins: [alerts],
  components: {
    PageHeader,
    Roles,
    Sections,
  },
  data: () => ({
    model: {
      id: null,
      roles: [],
      sections: [],
    },
  }),
  async mounted() {
    if (this.id) await this.getReorganization();
  },
  computed: {
    headers() {
      return {
        page: {
          icon: 'fas fa-calculator',
          title,
          routes: [
            'Inicio',
            'Operaciones',
            'Mantenimiento de Dashboard',
            'Reorganizar Dashboard',
            title,
          ],
        },
        actions: [
          {
            text: 'Regresar',
            icon: 'fas fa-arrow-circle-left',
            variant: 'outline-success',
            click: () => this.$router.back(),
          },
          {
            text: 'Guardar',
            icon: 'fas fa-save',
            variant: 'success',
            click: this.save,
          },
        ],
      };
    },
    id() {
      return Number(this.$route.params.id);
    },
  },
  methods: {
    validate() {
      const hasRoles = Boolean(this.model.roles.length);
      if (!hasRoles) {
        this.ShowToast(
          'Alerta',
          'Es requerido al menos un rol para poder documentar.',
          'error'
        );

        return false;
      }
      const hasSections = Boolean(this.model.roles.length);
      if (!hasSections) {
        this.ShowToast(
          'Alerta',
          'Es requerido al menos una sección  para poder documentar.',
          'error'
        );
        return false;
      }
      return true;
    },
    async getReorganization() {
      const { data } = await getReorganization(this.id);
      this.model = data;
    },
    async save() {
      const valid = this.validate();
      if (!valid) return;

      const payload = {
        id: this.model.id,
        roles: this.model.roles.map(({ app, role }) => ({
          appId: app.id,
          roleId: role.id,
        })),
        sections: this.model.sections.map(({ id, order }) => ({
          sectionId: id,
          order,
        })),
      };

      try {
        await reorganize(payload);
        this.ShowToast('', 'Reorganización guardada exitosamente.', 'success');
        this.$router.back();
      } catch (error) {
        this.ShowToast(
          'Alerta',
          error.message || error.response.data?.message,
          'error'
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
